import { render, staticRenderFns } from "./FooterHomeRtl.vue?vue&type=template&id=5aa94aea&"
import script from "./FooterHomeRtl.vue?vue&type=script&lang=js&"
export * from "./FooterHomeRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports